import { Component } from '@angular/core';

@Component({
  selector: 'app-header',
  standalone: true,
  imports: [],
  template: `
      <div class="header_section d-flex align-items-center">
          <div class="container container-custom">
            <h5 class="m-0 text-white">ORTHO PMS PAYMENT</h5>
          </div>
      </div>
`,
})
export class HeaderComponent {

}
